import { Injectable } from '@angular/core';
import { HttpService } from '../services/http.service';
import { Subject } from 'rxjs';
import { FactoryService } from '../core/services/factory/factory.service';

@Injectable({
  providedIn: 'root',
})
export class AlertaService {
  private subject = new Subject<any>();
  private subjectAlert = new Subject<any>();

  // Observable string streams
  constructor(private httpService: HttpService, private factory: FactoryService) {}

  mensagem$ = this.subject.asObservable();
  notification$ = this.subjectAlert.asObservable();
  sendMessage(message: string) {
    this.subject.next(message);
  }

  sendUpdateNotifications(atualiza: boolean) {
    this.subjectAlert.next(atualiza);
  }

  clearMessages() {
    this.subject.next();
  }
  public async getAlertas(params?) {
    const url = '/Alerta';
    const options = await this.factory.defaultHttpHeaders();
    return await this.httpService.get(url, options);
  }
  public async getAlertaPorId(id: number) {
    const url = '/Alerta/' + id;
    const options = await this.factory.defaultHttpHeaders();
    return await this.httpService.get(url, options);
  }
  public async putAlerta(params?, request?) {
    const url = `/Alerta`;
    const options = await this.factory.defaultHttpHeaders(params);
    return await this.httpService.put(url, request, options);
  }
}
